"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const Switch_1 = __importDefault(require("@mui/material/Switch"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
exports.default = (0, mobx_react_1.observer)(({ field }) => (react_1.default.createElement("div", null,
    react_1.default.createElement("br", null),
    react_1.default.createElement(FormControlLabel_1.default, { label: field.label, control: react_1.default.createElement(Switch_1.default, { id: field.id, name: field.name, onChange: field.onToggle, onFocus: field.onFocus, onBlur: field.onBlur }) }),
    react_1.default.createElement("small", { id: "name-desc", className: "f7 black-60 db mt1 mb3 red" }, field.error))));
